import { type Language } from '@pkgs/api';

export type ExposePath = {
  path: string;
  language: Language;
};

export const PageVariant = {
  EXPOSE: 'expose',
  DEVELOPMENT_PROJECT: 'development-project',
  PRIVATE_OFFICE_PUBLIC: 'private-office-public',
  PRIVATE_OFFICE_RESTRICTED: 'private-office-restricted',
  PRIVATE_OFFICE_RESTRICTED_WITH_PASSWORD_PROTECTION: 'private-office-restricted-with-password-protection',
  PRIVATE_OFFICE_RESTRICTED_WITHOUT_PASSWORD_PROTECTION: 'private-office-restricted-without-password-protection',
} as const;
export type PageVariant = (typeof PageVariant)[keyof typeof PageVariant];
